import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { FiTrash2, FiEyeOff } from "react-icons/fi";
import DeleteModal from "../common/DeleteModal";
import AppointmentDetail from "./AppointmentDetail";
import BlogDetail from "./BlogDetail";
import PetParentDetail from "./PetParentDetail";
import PetFinderDetail from "./PetFinderDetail";
import PaymentDetail from "./PaymentDetail";
import VeterinarianDetail from "./VeterinarianDetail";

const DetailView = ({ type, data, onDelete, onEdit, onSave }) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  if (!data)
    return (
      <div className="px-6 pt-6 sm:px-10 sm:pt-10">No details available.</div>
    );

  const isAppointment = type === "appointment";
  const isPetParent = type === "pet-parent" || type === "pet-parents";
  const isBlog = type === "blog";
  const isPetFinder = type === "pet-finder";
  const isPayment = type === "payment";
  const isVeterinarian = type === "veterinarian";

  const getTitle = () => {
    if (isAppointment) return "Appointment Information";
    if (isPetParent) return "Pet Parent Profile";
    if (isBlog) return "Blogs and Article";
    if (isPetFinder) return "Lost Pet Listing";
    if (isPayment) return "Payment Information";
    if (isVeterinarian) return "Veterinarian Profile";
    return "Profile";
  };

  const getProfileType = () => {
    if (isAppointment) return "Appointment";
    if (isPetParent) return "Pet Parent";
    if (isBlog) return "Blog";
    if (isPetFinder) return "Pet Finder";
    if (isPayment) return "Payment";
    if (isVeterinarian) return "Veterinarian";
    return "Profile";
  };

  const renderDetailComponent = () => {
    if (isAppointment) return <AppointmentDetail data={data} />;
    if (isBlog) return <BlogDetail data={data} onSave={onSave} />;
    if (isPetParent) return <PetParentDetail data={data} />;
    if (isPetFinder) return <PetFinderDetail data={data} />;
    if (isPayment) return <PaymentDetail data={data} />;
    if (isVeterinarian) return <VeterinarianDetail data={data} />;
    return <div>Unknown detail type</div>;
  };

  return (
    <div className="relative min-h-screen bg-white font-inter px-4 sm:px-6 lg:px-10 pt-6 sm:pt-10 pb-20">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-6 sm:mb-8 gap-4 ">
        <div className="flex items-start sm:items-start">
          <button
            onClick={() => navigate(-1)}
            className="p-2 text-lg sm:text-2xl text-gray-800 hover:text-blue-600 mr-3 "
          >
            <MdOutlineArrowBackIos />
          </button>
          <div>
            <div className="text-xl sm:text-2xl font-bold text-black">
              {getTitle()}
            </div>
            <div className="text-gray-700 text-sm sm:text-base">
              View detailed information and take actions if needed.
            </div>
          </div>
        </div>

        {/* Delete/Hide Button (hidden on small screens) */}
        <button
          onClick={() => setModalOpen(true)}
          className="hidden sm:flex items-center justify-center gap-2 bg-[#2B80FF] hover:bg-blue-600 text-white font-medium px-4 sm:px-6 py-2 rounded-lg text-sm sm:text-base shadow transition-all"
        >
          {/* {isBlog ? "Hide" : "Delete"}{" "}
          {isBlog ? <FiEyeOff size={18} /> : <FiTrash2 size={18} />} */}
          Delete
        </button>
      </div>

      {/* Detail Content */}
      {renderDetailComponent()}

      {/* Footer Buttons */}
      <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 sm:gap-4 mt-8">
        {/* Delete / Hide Button (visible on mobile/tablet) */}
        <button
          onClick={() => setModalOpen(true)}
          className="flex sm:hidden items-center justify-center gap-2 bg-[#2B80FF] hover:bg-blue-600 text-white font-medium px-4 sm:px-6 py-2 rounded-lg text-sm sm:text-base shadow transition-all w-full"
        >
          {/* {isBlog ? "Hide" : "Delete"}{" "}
          {isBlog ? <FiEyeOff size={18} /> : <FiTrash2 size={18} />} */}
          Delete
        </button>

        {/* Cancel Button */}
        <button
          onClick={() => navigate(-1)}
          className="bg-white border border-[#2B80FF] text-gray-700 rounded-lg px-6 py-2 text-sm sm:text-base font-medium hover:bg-gray-200 shadow-sm w-full sm:w-auto"
        >
          Cancel
        </button>

        {/* Edit Button */}
        <button
          onClick={onEdit}
          className="bg-[#2B80FF] border border-[#2B80FF] text-white rounded-lg px-6 py-2 text-sm sm:text-base font-medium hover:bg-blue-700 shadow-sm w-full sm:w-auto"
        >
          Edit
        </button>
      </div>

      {/* Delete Modal */}
      <DeleteModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onDelete={onDelete}
        profileType={getProfileType()}
      />
    </div>
  );
};

export default DetailView;
